import { ArrowRight, ArrowDropDown } from '@mui/icons-material';
import { unstable_composeClasses as composeClasses, Box, IconButton, Typography } from '@mui/material';
import {
  useGridSelector,
  gridFilteredDescendantCountLookupSelector,
  getDataGridUtilityClass,
  GridRenderCellParams,
  DataGridProProps,
  useGridApiContext,
  useGridRootProps,
  GridGroupNode,
} from '@mui/x-data-grid-pro';
import { MouseEventHandler, ReactNode } from 'react';

type OwnerState = { classes: DataGridProProps['classes'] };

const useUtilityClasses = (ownerState: OwnerState) => {
  const { classes } = ownerState;

  const slots = {
    root: ['treeDataGroupingCell'],
    toggle: ['treeDataGroupingCellToggle'],
  };

  return composeClasses(slots, getDataGridUtilityClass, classes);
};

export const CustomGridTreeDataGroupingCell = (props: GridRenderCellParams<any, any, any, GridGroupNode>) => {
  const { id, field, formattedValue, rowNode } = props;
  const customContent = (props as GridRenderCellParams<any, any, any, GridGroupNode> & { customContent?: ReactNode })
    .customContent;

  const rootProps = useGridRootProps();
  const apiRef = useGridApiContext();
  const ownerState: OwnerState = { classes: rootProps.classes };
  const classes = useUtilityClasses(ownerState);
  const filteredDescendantCountLookup = useGridSelector(apiRef, gridFilteredDescendantCountLookupSelector);

  const filteredDescendantCount = filteredDescendantCountLookup[rowNode.id] ?? 0;

  const Icon = rowNode.childrenExpanded ? ArrowDropDown : ArrowRight;

  const handleClick: MouseEventHandler<HTMLButtonElement> = (event) => {
    apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
    apiRef.current.setCellFocus(id, field);
    event.stopPropagation();
  };

  const content = customContent ?? (formattedValue === undefined ? rowNode.groupingKey : formattedValue);

  return (
    <Box className={classes.root}>
      <div className={classes.toggle}>
        {filteredDescendantCount > 0 && (
          <IconButton
            size="small"
            onClick={handleClick}
            tabIndex={-1}
            aria-label={
              rowNode.childrenExpanded
                ? apiRef.current.getLocaleText('treeDataCollapse')
                : apiRef.current.getLocaleText('treeDataExpand')
            }
          >
            <Icon fontSize="inherit" />
          </IconButton>
        )}
      </div>
      {rowNode.depth === 0 ? (
        <Typography component="span" variant="overline">
          {content}
        </Typography>
      ) : (
        <span>{content}</span>
      )}
    </Box>
  );
};
